import axios from "axios";

export default {
  state: () => ({
    ubicaciones: [],
  }),
  mutations: {
    setUbicaciones(state, payload) {
      state.ubicaciones = payload;
    },
  },
  actions: {
    async getUbicaciones(context) {
      let resp = await axios.get("/ubicacion-dinero");
      context.commit("setUbicaciones", resp.data);
    },
  },
  getters: {
    getUbicaciones(state) {
      try {
        return state.ubicaciones;
      } catch (e) {
        return [];
      }
    },
  },
};
